//Primary server
exports.adress="https://290d122.mars1.mars-hosting.com/API/";

//Testing server
// exports.adress="https://125k122.e2.mars-hosting.com/API/";